import React, { useEffect } from 'react';
import styles from './IntroVideo.module.scss';

const VIDEO_END_TIMEOUT_MS = 5000;
const INTRO_TIMEOUT_MS = 7000;

const introVideoSrc =
  'https://yleerilliset.akamaized.net/Areena/areena-static/YLE_AREENA_ALKUTUNNUS_2025.mp4';

type Props = {
  setIntroVideoShown: React.Dispatch<React.SetStateAction<boolean>>;
};

export const IntroVideo = ({ setIntroVideoShown }: Props) => {
  useEffect(() => {
    const video = document.createElement('video');
    video?.addEventListener('ended', () => {
      setIntroVideoShown(true);
    });
    video?.addEventListener('canplay', () => {
      window.setTimeout(() => {
        setIntroVideoShown(true);
      }, VIDEO_END_TIMEOUT_MS);
    });

    video?.setAttribute('src', introVideoSrc);
    video?.setAttribute('autoPlay', 'true');
    document.getElementById('introVideoWrapper')?.appendChild(video);
    const playPromise = video?.play();

    playPromise?.catch(err => {
      console.log('Play promise rejected', err);
      setIntroVideoShown(true);
    });

    window.setTimeout(() => {
      setIntroVideoShown(true);
    }, INTRO_TIMEOUT_MS);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.introVideoWrapper} id="introVideoWrapper"></div>
  );
};
